/** Shared nav labels — sidebar, bottom bar, and mobile header. */
export const NAV_PAGE_LABELS = {
  home: "الرئيسية",
  dashboard: "الرئيسية",
  "my-profile": "ملفي الشخصي",
  "profile-completion": "اكتمال الملفات",
  notifications: "إشعاراتي",
  announcements: "الإعلانات",
  "announcements-manage": "إدارة الإعلانات",
  "company-policies": "لائحة الشركة",
  "company-policies-manage": "إدارة اللائحة",
  "my-days": "أيامي",
  attendance: "حضور وانصراف التطبيق",
  overtime: "طلب إضافي",
  "overtime-grant": "منح إضافي",
  wfh: "العمل عن بُعد",
  leave: "طلباتي",
  advance: "السلف",
  "my-complaints": "الشكاوى والاستفسارات",
  appeals: "تظلماتي",
  evaluations: "تقييم الأداء",
  agenda: "أجندة أبيض وأسود",
  "internal-jobs": "وظائف داخلية",
  team: "فريقي",
  "team-leave-overtime": "إجازات وإضافي الفريق",
  approvals: "الموافقات",
  "branch-timesheet": "الخطة الأسبوعية",
  penalties: "الجزاءات",
  "received-complaints": "الشكاوى والاستفسارات الواردة",
  investigations: "التحقيقات",
  resignations: "طلبات الاستقالة",
  recruitment: "التوظيف",
  departments: "الفروع والأقسام",
  "approval-cycles": "سايكل الموافقات",
  "leave-grant": "منح إجازة وأذونات",
  "advance-approvals": "موافقات السلف",
  "team-approvals": "موافقات الإجازات",
  employees: "الموظفين",
  "social-insurance": "التأمينات",
  "work-mode": "نظام الحضور",
  "flexible-manual-attendance": "حضور يدوي مرن",
  "kmt-upload": "مزامنة البصمة",
  "attendance-summary": "تقرير الحضور",
  "inventory-night": "الجرد",
  "branch-shift-hours": "مواعيد الورديات",
  "custom-schedule": "مواعيد مخصصة",
  "transport-lines": "خطوط المواصلات",
  "attendance-regulations": "لوائح الحضور",
  "kmt-payroll": "المرتبات",
  "sales-targets": "تارجت المبيعات",
  "my-payslip": "كشف الراتب",
  shortage: "عجز",
  reports: "التقارير",
  "evaluations-manage": "إدارة التقييم",
  "evaluations-results": "نتائج التقييمات",
  "advance-disbursement": "توجيه السلف",
  "advance-confirm": "تأكيد الصرف",
  "advance-ledger": "سجل السلف",
  "cash-entitlement-create": "صرف مستحقات نقدية",
  "cash-entitlement-disbursement": "توجيه المستحقات",
  "cash-entitlement-confirm": "تأكيد المستحقات",
  "cash-entitlement-ledger": "سجل المستحقات",
  accounts: "إنشاء الحسابات",
  "brands-admin": "إدارة البراندات",
  "company-modules": "موديولات الشركات",
  requests: "جميع الطلبات",
};

export const NAV_SECTIONS = {
  daily: "يومي",
  me: "حسابي",
  team: "الفريق",
  people: "الأفراد",
  requests: "الطلبات",
  attendance: "الحضور",
  pay: "الرواتب والصرف",
};

function item(id, icon, section, labelOverride) {
  return {
    id,
    icon,
    section,
    label: labelOverride || NAV_PAGE_LABELS[id] || id,
  };
}

export const NAV_ITEMS_BY_ROLE = {
  employee: [
    item("home", "LayoutGrid", "daily"),
    item("my-profile", "UserCircle", "me"),
    item("my-payslip", "Banknote", "me", "كشف الراتب"),
    item("notifications", "Bell", "daily"),
    item("announcements", "Megaphone", "daily"),
    item("company-policies", "BookOpen", "me"),
    item("my-days", "CalendarDays", "daily"),
    item("attendance", "Clock", "requests"),
    item("overtime", "Timer", "requests"),
    item("wfh", "Home", "requests"),
    item("leave", "FileText", "requests"),
    item("advance", "Landmark", "requests"),
    item("my-complaints", "MessageSquareWarning", "me"),
    item("investigations", "Scale", "me", "تحقيقاتي"),
    item("appeals", "ShieldCheck", "me"),
    item("evaluations", "ClipboardCheck", "me", "تقييم الأداء 360 درجة"),
    item("agenda", "BookMarked", "me", "أجندتي"),
    item("internal-jobs", "UserPlus", "me"),
  ],

  manager: [
    item("home", "LayoutGrid", "daily"),
    item("my-profile", "UserCircle", "me"),
    item("my-payslip", "Banknote", "me", "كشف الراتب"),
    item("notifications", "Bell", "daily"),
    item("announcements", "Megaphone", "daily"),
    item("company-policies", "BookOpen", "me"),
    item("my-days", "CalendarDays", "daily"),
    item("team", "Users", "team"),
    item("agenda", "BookMarked", "team"),
    item("team-leave-overtime", "CalendarDays", "team"),
    item("approvals", "ShieldCheck", "team"),
    item("attendance", "Clock", "me"),
    item("overtime", "Timer", "me"),
    item("wfh", "Home", "me"),
    item("branch-timesheet", "CalendarDays", "team"),
    item("penalties", "AlertTriangle", "team"),
    item("appeals", "MessageSquareWarning", "team", "التظلمات"),
    item("received-complaints", "MessageSquareWarning", "team"),
    item("investigations", "Scale", "team", "التحقيقات"),
    item("resignations", "LogOut", "team"),
    item("my-complaints", "MessageSquareWarning", "me"),
    item("leave", "FileText", "me"),
    item("advance", "Landmark", "me"),
    item("evaluations", "ClipboardCheck", "me", "تقييم الأداء 360 درجة"),
    item("recruitment", "UserPlus", "team"),
  ],

  "department-manager": [
    item("dashboard", "LayoutGrid", "daily"),
    item("my-profile", "UserCircle", "me"),
    item("my-payslip", "Banknote", "me", "كشف الراتب"),
    item("notifications", "Bell", "daily"),
    item("announcements", "Megaphone", "daily"),
    item("company-policies", "BookOpen", "me"),
    item("my-days", "CalendarDays", "daily"),
    item("departments", "Users", "team"),
    item("agenda", "BookMarked", "team"),
    item("team-leave-overtime", "CalendarDays", "team"),
    item("approvals", "ShieldCheck", "team"),
    item("attendance", "Clock", "me"),
    item("overtime", "Timer", "me"),
    item("wfh", "Home", "me"),
    item("branch-timesheet", "CalendarDays", "team"),
    item("penalties", "AlertTriangle", "team"),
    item("appeals", "MessageSquareWarning", "team", "التظلمات"),
    item("received-complaints", "MessageSquareWarning", "team"),
    item("investigations", "Scale", "team", "التحقيقات"),
    item("resignations", "LogOut", "team"),
    item("leave", "FileText", "me"),
    item("advance", "Landmark", "me"),
    item("my-complaints", "MessageSquareWarning", "me"),
    item("evaluations", "ClipboardCheck", "me", "تقييم الأداء 360 درجة"),
    item("recruitment", "UserPlus", "team"),
  ],

  hr: [
    item("dashboard", "LayoutGrid", "daily"),
    item("my-profile", "UserCircle", "me"),
    item("my-payslip", "Banknote", "me", "كشف الراتب"),
    item("notifications", "Bell", "daily"),
    item("announcements", "Megaphone", "daily"),
    item("company-policies", "BookOpen", "me"),
    item("announcements-manage", "Megaphone", "daily"),
    item("company-policies-manage", "BookOpen", "daily"),
    item("my-days", "CalendarDays", "daily"),
    item("leave", "FileText", "me"),
    item("leave-grant", "CalendarDays", "requests", "منح إجازة وأذونات وراحات"),
    item("advance", "Landmark", "me"),
    item("attendance", "Clock", "me"),
    item("overtime", "Timer", "me"),
    item("overtime-grant", "Timer", "requests"),
    item("wfh", "Home", "me"),
    item("advance-approvals", "ShieldCheck", "requests"),
    item("cash-entitlement-create", "Wallet", "pay"),
    item("team-approvals", "Users", "requests"),
    item("received-complaints", "Inbox", "requests", "متابعة الشكاوى والاستفسارات"),
    item("investigations", "Scale", "requests", "التحقيقات"),
    item("resignations", "LogOut", "requests"),
    item("employees", "Users", "people"),
    item("agenda", "BookMarked", "people"),
    item("social-insurance", "Shield", "people"),
    item("profile-completion", "ClipboardCheck", "people"),
    item("work-mode", "Clock", "attendance"),
    item("flexible-manual-attendance", "ClipboardCheck", "attendance"),
    item("departments", "Users", "people", "الفروع والإدارات"),
    item("approval-cycles", "Settings", "people"),
    item("kmt-upload", "Upload", "attendance"),
    item("branch-timesheet", "CalendarDays", "attendance"),
    item("inventory-night", "Package", "attendance"),
    item("branch-shift-hours", "Clock", "attendance", "مواعيد ورديات الفروع"),
    item("custom-schedule", "Clock", "attendance"),
    item("transport-lines", "Bus", "attendance"),
    item("attendance-regulations", "Scale", "attendance"),
    item("kmt-payroll", "Wallet", "pay"),
    item("sales-targets", "Wallet", "pay", "تارجت المبيعات"),
    item("penalties", "AlertTriangle", "requests"),
    item("shortage", "Banknote", "pay"),
    item("appeals", "MessageSquareWarning", "requests", "التظلمات"),
    item("reports", "FileText", "daily"),
    item("evaluations-results", "BarChart3", "people", "نتائج التقييمات"),
    item("evaluations-manage", "ClipboardCheck", "people", "تقييم الأداء 360 درجة"),
    item("evaluations", "ClipboardCheck", "me", "تقييمي 360 درجة"),
    item("recruitment", "UserPlus", "people"),
  ],

  gm: [
    item("dashboard", "LayoutGrid", "daily"),
    item("my-profile", "UserCircle", "me"),
    item("my-payslip", "Banknote", "me", "كشف الراتب"),
    item("notifications", "Bell", "daily"),
    item("announcements", "Megaphone", "daily"),
    item("company-policies", "BookOpen", "me"),
    item("announcements-manage", "Megaphone", "daily"),
    item("company-policies-manage", "BookOpen", "daily"),
    item("leave-grant", "CalendarDays", "requests", "منح إجازة وأذونات وراحات"),
    item("approvals", "ShieldCheck", "requests"),
    item("departments", "Users", "people", "الفروع والإدارات"),
    item("approval-cycles", "Settings", "people"),
    item("employees", "Users", "people"),
    item("agenda", "BookMarked", "people"),
    item("social-insurance", "Shield", "people"),
    item("profile-completion", "ClipboardCheck", "people"),
    item("work-mode", "Clock", "attendance"),
    item("flexible-manual-attendance", "ClipboardCheck", "attendance"),
    item("requests", "FileText", "requests"),
    item("resignations", "LogOut", "requests"),
    item("received-complaints", "Inbox", "requests", "الشكاوى والاستفسارات"),
    item("investigations", "Scale", "requests", "التحقيقات"),
    item("kmt-upload", "Upload", "attendance"),
    item("branch-timesheet", "CalendarDays", "attendance"),
    item("branch-shift-hours", "Clock", "attendance", "مواعيد ورديات الفروع"),
    item("custom-schedule", "Clock", "attendance"),
    item("transport-lines", "Bus", "attendance"),
    item("attendance-regulations", "Scale", "attendance"),
    item("kmt-payroll", "Wallet", "pay"),
    item("sales-targets", "Wallet", "pay", "تارجت المبيعات"),
    item("penalties", "AlertTriangle", "requests"),
    item("shortage", "Banknote", "pay"),
    item("appeals", "MessageSquareWarning", "requests", "التظلمات"),
    item("reports", "FileText", "daily"),
    item("evaluations-results", "BarChart3", "people", "نتائج التقييمات"),
    item("evaluations-manage", "ClipboardCheck", "people", "تقييم الأداء 360 درجة"),
    item("evaluations", "ClipboardCheck", "me", "تقييمي 360 درجة"),
    item("recruitment", "UserPlus", "people"),
  ],

  owner: [
    item("dashboard", "LayoutGrid", "daily"),
    item("my-profile", "UserCircle", "me"),
    item("notifications", "Bell", "daily"),
    item("announcements", "Megaphone", "daily"),
    item("company-policies", "BookOpen", "me"),
    item("departments", "Users", "people", "الفروع والإدارات"),
    item("employees", "Users", "people"),
    item("agenda", "BookMarked", "people"),
    item("social-insurance", "Shield", "people"),
    item("profile-completion", "ClipboardCheck", "people"),
    item("requests", "FileText", "requests"),
    item("resignations", "LogOut", "requests"),
    item("received-complaints", "Inbox", "requests", "الشكاوى والاستفسارات"),
    item("investigations", "Scale", "requests", "التحقيقات"),
    item("branch-timesheet", "CalendarDays", "attendance"),
    item("inventory-night", "Package", "attendance"),
    item("kmt-payroll", "Wallet", "pay"),
    item("attendance-regulations", "Scale", "attendance"),
    item("transport-lines", "Bus", "attendance"),
    item("penalties", "AlertTriangle", "requests"),
    item("shortage", "Banknote", "pay"),
    item("appeals", "MessageSquareWarning", "requests", "التظلمات"),
    item("reports", "FileText", "daily"),
    item("recruitment", "UserPlus", "people"),
  ],

  "platform-admin": [
    item("company-modules", "Settings", null, "اشتراكات الشركات"),
  ],

  admin: [
    item("accounts", "ShieldCheck"),
    item("my-profile", "UserCircle"),
    item("employees", "Users"),
    item("agenda", "BookMarked"),
    item("social-insurance", "Shield"),
    item("profile-completion", "ClipboardCheck"),
    item("work-mode", "Clock"),
    item("departments", "Users", null, "الفروع والإدارات"),
    item("approval-cycles", "Settings", null),
    item("announcements-manage", "Megaphone"),
    item("company-policies-manage", "BookOpen"),
    item("leave-grant", "CalendarDays", null, "منح إجازة وأذونات وراحات"),
    item("evaluations-manage", "ClipboardCheck", null, "تقييم الأداء 360 درجة"),
    item("recruitment", "UserPlus"),
    item("investigations", "Scale", null, "التحقيقات"),
    item("brands-admin", "Settings", null, "إدارة براندات White-label"),
  ],
};

export function groupNavItems(items) {
  const hasSections = (items || []).some((entry) => entry.section);
  if (!hasSections) {
    return [{ id: null, label: null, items: items || [] }];
  }

  const order = [];
  const buckets = new Map();
  (items || []).forEach((entry) => {
    const key = entry.section || "_other";
    if (!buckets.has(key)) {
      buckets.set(key, []);
      order.push(key);
    }
    buckets.get(key).push(entry);
  });

  return order.map((id) => ({
    id,
    label: NAV_SECTIONS[id] || null,
    items: buckets.get(id),
  }));
}

export function getPageTitle(
  activeId,
  fallback = "الخدمة الذاتية",
  industryLabels,
) {
  if (!activeId) return fallback;
  if (activeId === "sales-targets" && industryLabels?.incentivesNav) {
    return industryLabels.incentivesNav;
  }
  if (activeId === "company-modules" && industryLabels?.entityPlural) {
    return `موديولات ${industryLabels.entityPlural}`;
  }
  if (activeId === "branch-shift-hours" && industryLabels?.siteShiftHours) {
    return industryLabels.siteShiftHours;
  }
  if (activeId === "branch-timesheet" && industryLabels?.weeklyPlan) {
    return industryLabels.weeklyPlan;
  }
  return NAV_PAGE_LABELS[activeId] || fallback;
}

/** Remap static nav copy when the tenant is a factory. */
export function applyIndustryNavLabels(items, industryLabels) {
  if (!industryLabels || !Array.isArray(items)) return items || [];
  return items.map((entry) => {
    if (entry.id === "sales-targets") {
      return { ...entry, label: industryLabels.incentivesNav };
    }
    if (entry.id === "company-modules") {
      return {
        ...entry,
        label: `اشتراكات ${industryLabels.entityPlural}`,
      };
    }
    if (entry.id === "branch-shift-hours") {
      return { ...entry, label: industryLabels.siteShiftHours };
    }
    if (entry.id === "branch-timesheet") {
      return { ...entry, label: industryLabels.weeklyPlan };
    }
    return entry;
  });
}
